/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import { ImageHelper } from "@nf/common";
import { RouteHelper } from "helpers/routeHelper";

import AppImage from "components/AppImage";
import Button from "components/Button";
import LinkWithLocale from "components/LinkWithLocale";
import MediaAdditionalInfo from "components/Media/MediaAdditionalInfo";
import MoreInfoButton from "components/MoreInfoButton";
import MyListButton from "components/MyListButton";
import PlayButton from "components/PlayButton";
import type { IListComponentItemProps } from "../../models";

import styles from "./ListComponentItemHighlight.module.scss";

type IListComponentItemHighlightProps = IListComponentItemProps;

export const ListComponentItemHighlight = ({
  media,
  isPlaceholder,
  index,
}: IListComponentItemHighlightProps) => {
  if (!media || isPlaceholder) {
    return <div className={styles.item} />;
  }

  return (
    <div className={styles.item}>
      <AppImage
        src={ImageHelper.getHeroFrontpageUrl(media?.Images) || ""}
        alt={media.Title || ""}
        sizes="100vw"
        fill={true}
        isLCP={index === 0}
        className={styles.image}
      />

      <div className={styles.gradient} />

      <LinkWithLocale href={RouteHelper.goToDetails(media)}>
        <a className={styles.link} aria-label={media.Title} />
      </LinkWithLocale>

      <div className={styles.container}>
        <div className={styles.content}>
          <h1 className={styles.title}>{media?.Description}</h1>

          <div className={styles.metadata}>
            <Button variant="quaternary" href={RouteHelper.goToDetails(media)}>
              {media.Title}
            </Button>

            <MediaAdditionalInfo
              type={media.MediaTypeCode}
              year={media.Year}
              categories={media.Categories}
              className={styles.additionalDescription}
            />
          </div>
        </div>

        <div className={styles.actions}>
          <PlayButton media={media} />

          <MoreInfoButton media={media} />

          <MyListButton media={media} />
        </div>
      </div>
    </div>
  );
};
